import { render, staticRenderFns } from "./OtherActivites.vue?vue&type=template&id=19ca4551&"
import script from "./OtherActivites.vue?vue&type=script&lang=ts&"
export * from "./OtherActivites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports